import type { DriveStep } from 'driver.js';

export const adminUsersTourId = 'admin:users';

export const adminUsersSteps: DriveStep[] = [
  {
    element: '[data-tour="admin:users-filters"]',
    popover: {
      title: 'Фильтры',
      description:
        'Фильтры пользователей: по роли (администратор, менеджер, сотрудник, клиент) и статусу активности.',
    },
  },
  {
    element: '[data-tour="admin:users-list"]',
    popover: {
      title: 'Пользователи',
      description:
        'Список всех пользователей платформы. Кликните на строку для просмотра деталей.',
    },
  },
  {
    element: '[data-tour="admin:help-btn"]',
    popover: {
      title: 'Помощь',
      description:
        'Помощь.',
    },
  },
];
